@let $prepend = prepend();
@let $append = append();

@if ($prepend && !$prepend.hide()) {
  <div class="col-auto">
    <ng-container [ngTemplateOutlet]="$prepend.template" />
  </div>
}

<div
  class="col overflow-hidden"
  [autoClose]="autoClose()"
  [closeDelay]="closeDelay()"
  [container]="container()"
  [disableTooltip]="disableTooltip() || !isTruncated()"
  [ngbTooltip]="tooltip()"
  [openDelay]="openDelay()"
  [placement]="placement()"
  [tooltipClass]="tooltipClass()"
  [triggers]="triggers()">
  <span
    #content
    class="d-inline-block align-top text-overflow">
    <ng-content />
  </span>
</div>

@if ($append && !$append.hide()) {
  <div class="col-auto">
    <ng-container [ngTemplateOutlet]="$append.template" />
  </div>
}
